var { isMobile } = require("./lib/breakpoints");

var { Sidechain } = require("@nprapps/sidechain");
Sidechain.registerGuest();
